import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";
import { seoArticlesList } from "@/mocks/seo-articles";

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link
              to="/"
              className="font-heading text-xl font-semibold text-foreground-950 hover:text-primary-600 transition-colors duration-200"
            >
              Vigorbuy<span className="text-accent-500">Spreadsheet</span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              The ultimate product discovery platform. Browse organized categories, find the best products, and shop smarter with curated spreadsheet databases.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-900 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">Home</Link>
              <Link to="/shopping-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">Shopping Guide</Link>
              <Link to="/kakobuy-vs-vigorbuy" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">Kakobuy vs Vigorbuy</Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">Main Website</a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-900 mb-4">Popular Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-900 mb-4">SEO Guides</h4>
            <div className="flex flex-col gap-2.5">
              {seoArticlesList.slice(0, 6).map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 truncate max-w-[200px]"
                >
                  {article.title}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} VigorbuySpreadsheet. All rights reserved. This site provides informational shopping guides and links to external product resources.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/shopping-guide" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200">Shopping Guide</Link>
            <Link to="/kakobuy-vs-vigorbuy" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200">Comparison</Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200"
            >
              Visit Main Site
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}